import { render, staticRenderFns } from "./lazyblock_library.vue?vue&type=template&id=56315532&scoped=true"
import script from "./lazyblock_library.vue?vue&type=script&lang=js"
export * from "./lazyblock_library.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_library.vue?vue&type=style&index=0&id=56315532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56315532",
  null
  
)

export default component.exports